//TODO: Make these immutable
export const FETCH_CITIES = "FETCH_CITIES";
export const FETCH_LOCALITIES = "FETCH_LOCALITIES";
export const FETCH_LOCALIZATION_KEYS_PGR = "FETCH_LOCALIZATION_KEYS_PGR";
export const UPDATE_I18NSTORE_CITY_PGR = "UPDATE_I18nStore_CITY_PGR";
export const FETCH_LOCALITY_LOCALIZATION_KEYS_PGR = "FETCH_LOCALITY_LOCALIZATION_KEYS_PGR";
export const CREATE_LOCALITY_DROPDOWN = "CREATE_LOCALITY_DROPDOWN";
export const UPDATE_I18nStore_LOCALITY_PGR = "UPDATE_I18nStore_LOCALITY_PGR";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const FETCH_LANGUAGES = "FETCH_LANGUAGES";
export const FETCH_COMPLAINTS = "FETCH_COMPLAINTS";
export const FETCH_ALL_BUSINESSS_SERVICES = "FETCH_ALL_BUSINESSS_SERVICES";
export const FETCH_BUSINESS_SERVICE_BY_ID = "FETCH_BUSINESS_SERVICE_BY_ID";
export const UPDATE_COMPLAINT = "UPDATE_COMPLAINT";
export const CREATE_COMPLAINT = "CREATE_COMPLAINT";
export const APPLY_INBOX_FILTER = "APPLY_INBOX_FILTER";
